<!-- eslint-disable -->
<template>
  <CommonPages id="disclaimer" :class="['disclaimer-page']" :titlePrefix="pageMetaTitle"
    :metaDescription="pageMetaDescription">
    <LegalContentLayout title="Disclaimer">
      <div class="legal-richtext">
        <div v-html="disclaimerBody"></div>
      </div>
    </LegalContentLayout>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import LegalContentLayout from '@/components/legal/LegalContentLayout.vue'
import { getContentTextMap, getText, renderTemplate } from '@/utils/contentText';
import { stripLeadingRichTextTitle } from '@/utils/richTextTitle';

import '@/css/common.scss';

const DISCLAIMER_BODY = 'Disclaimer<br>The information provided on this website is for general informational and educational purposes only. By accessing our rankings and city evaluations, you acknowledge and agree to the following:<br><br>1. Subjective Nature of Ratings<br>The scores and rankings for the 50 global cities featured on this site are based on our own proprietary methodology and editorial judgment.<br><br>- Editorial Opinion: These ratings represent our subjective evaluation of urban livability and are not intended to be interpreted as absolute or universal facts.<br><br>- Metric Diversity: While we use five specific indicators to grade each city, different individuals may prioritize these factors differently based on personal needs and preferences.<br><br>2. No Professional Advice<br>The content on this website does not constitute professional, legal, financial, or real estate advice.<br><br>- Due Diligence: We strongly recommend that users conduct their own independent research and consult with qualified professionals before making significant life decisions, such as relocating to a new city or investing in international property.<br><br>- Personal Risk: Any reliance you place on the information found on this website is strictly at your own risk.<br><br>3. Accuracy of Information<br>While we strive to provide high-quality evaluations, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or suitability of the city data. Urban conditions—including safety, infrastructure, and environmental factors—can change rapidly. We are not responsible for any information that may become outdated or inaccurate.<br><br>4. Limitation of Liability<br>In no event will we be liable for any loss or damage, including without limitation, indirect or consequential loss or damage, arising from the use of this website or the information contained herein.<br><br>5. External Links<br>Through this website, you may be able to link to other websites which are not under our control. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.';

export default {
  name: 'Disclaimer',
  components: {
    CommonPages,
    LegalContentLayout
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      'domainConfig',
    ]),
    contentText () {
      return getContentTextMap(this.domainConfig);
    },
    disclaimerBody () {
      const template = getText(this.contentText, 'DISCLAIMER_BODY', DISCLAIMER_BODY);
      const rendered = renderTemplate(template, {
        SITE_NAME: this.domainConfig?.siteName || 'SITE_NAME',
        CONTACT_EMAIL: this.domainConfig?.IAMEMAIL || this.contentText.CONTACT_EMAIL || 'CONTACT_EMAIL'
      });
      return stripLeadingRichTextTitle(rendered, 'Disclaimer');
    },
    pageMetaTitle () {
      return getText(this.contentText, 'DISCLAIMER_META_TITLE', 'Disclaimer');
    },
    pageMetaDescription () {
      return getText(this.contentText, 'HOME_META_DESCRIPTION', 'Disclaimer and limitations of our website information');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.legal-richtext {
	display: flex;
	flex-direction: column;
	gap: rem(8);
}
</style>
